export default "__VITE_ASSET__BXhbTUDP__"